import React, {ChangeEvent, useState} from 'react';
import "./CreateAccountEnterprise.scss";

export interface InterfaceCreateAccountEnterprise {
    companyName: string;
    companySiret: string;
    companyLocation: string;
    declarationLocation: string;
    tjm: number;
    logo: string;
    vl: boolean;
    tvaNumber: string;
}

export type CreateAccountEnterpriseProps = {
    handlerChange: (dataEnterprise: InterfaceCreateAccountEnterprise) => void;
    verifyInput: boolean;
};

const CreateAccountEnterprise: React.FC<CreateAccountEnterpriseProps> = (props: CreateAccountEnterpriseProps) => {

    const [dataEnterprise, setDataEnterprise] = useState<InterfaceCreateAccountEnterprise>({
        companyLocation: "",
        companyName: "",
        companySiret: "",
        declarationLocation: "",
        tjm: 400,
        logo: "",
        vl: true,
        tvaNumber: ""
    });

    const eventChange = (key: keyof InterfaceCreateAccountEnterprise, value: string | number | boolean) => {
        const v: any = {...dataEnterprise, [key]: value};
        setDataEnterprise(v);
        props.handlerChange(v);
    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const file: File = e.target.files[0];
            file.text().then((result) => eventChange("logo", result));
        }
    };

    const nameError = props.verifyInput && dataEnterprise.companyName === "";
    const siretError = props.verifyInput && dataEnterprise.companySiret === "";
    const locationError = props.verifyInput && dataEnterprise.companyLocation === "";
    const declarationError = props.verifyInput && dataEnterprise.declarationLocation === "";
    const tjmError = props.verifyInput && dataEnterprise.tjm === 0;

    return (
        <>
            <div className="caSectionHeader">
                <h1 className="caSectionTitle">Données de l'Entreprise</h1>
                <p className="caSectionSubtitle">
                    Établissez les fondations de votre atelier. Ces informations seront utilisées sur vos registres,
                    factures et déclarations officielles.
                </p>
            </div>

            <div className="caCard">
                <div className="caFormGrid">
                    <div className={`caField caFieldFull${nameError ? " caFieldError" : ""}`}>
                        <label htmlFor="companyName">Nom de l'entreprise *</label>
                        <input id="companyName" type="text" placeholder="Ex. Studio Lumière"
                               value={dataEnterprise.companyName}
                               onChange={(e) => eventChange("companyName", e.target.value)}/>
                    </div>

                    <div className={`caField${siretError ? " caFieldError" : ""}`}>
                        <label htmlFor="siret">SIRET *</label>
                        <input id="siret" type="text" placeholder="14 chiffres"
                               value={dataEnterprise.companySiret}
                               onChange={(e) => eventChange("companySiret", e.target.value)}/>
                    </div>

                    <div className="caField">
                        <label htmlFor="tva">N° TVA intracommunautaire</label>
                        <input id="tva" type="text" placeholder="FR XX XXXXXXXXX"
                               value={dataEnterprise.tvaNumber}
                               onChange={(e) => eventChange("tvaNumber", e.target.value)}/>
                    </div>

                    <div className={`caField caFieldFull${locationError ? " caFieldError" : ""}`}>
                        <label htmlFor="address">Adresse de l'entreprise *</label>
                        <input id="address" type="text" placeholder="123 Rue du Commerce"
                               value={dataEnterprise.companyLocation}
                               onChange={(e) => eventChange("companyLocation", e.target.value)}/>
                    </div>

                    <div className={`caField${declarationError ? " caFieldError" : ""}`}>
                        <label htmlFor="declCity">Ville pour les déclarations *</label>
                        <input id="declCity" type="text" placeholder="Paris"
                               value={dataEnterprise.declarationLocation}
                               onChange={(e) => eventChange("declarationLocation", e.target.value)}/>
                    </div>

                    <div className={`caField${tjmError ? " caFieldError" : ""}`}>
                        <label htmlFor="tjm">TJM par défaut (€) *</label>
                        <input id="tjm" type="number" min={0} max={1000} placeholder="0.00"
                               value={dataEnterprise.tjm}
                               onChange={(e) => eventChange("tjm", parseFloat(e.target.value) || 0)}/>
                    </div>

                    <div className="caField caFieldFull">
                        <div className="caCheckboxRow">
                            <input type="checkbox" id="vl"
                                   checked={dataEnterprise.vl}
                                   onChange={(e) => eventChange("vl", e.target.checked)}/>
                            <label htmlFor="vl">Versement libératoire</label>
                        </div>
                    </div>

                    <div className="caField caFieldFull">
                        <label>Logo de l'entreprise</label>
                        <label className="caUploader" htmlFor="logoFile">
                            <div className="caUploaderIcon">
                                <span className="material-symbols-outlined">cloud_upload</span>
                            </div>
                            <div className="caUploaderText">Déposez votre logo ici</div>
                            <div className="caUploaderHint">SVG uniquement (max. 5 Mo)</div>
                            <div className="caUploaderBtn">Choisir un fichier</div>
                            <input id="logoFile" type="file" accept=".svg" style={{display: "none"}}
                                   onChange={handleFileChange}/>
                        </label>
                        {dataEnterprise.logo && (
                            <img className="caUploaderPreview"
                                 src={'data:image/svg+xml;base64,' + Buffer.from(dataEnterprise.logo).toString("base64")}
                                 alt="logo"/>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateAccountEnterprise;
